import { useState as s, useLayoutEffect as d } from "react";
function o(t) {
  const e = t.startsWith("@media ") ? t.replace("@media ", "") : t, [c, i] = s(() => window.matchMedia(e).matches);
  function a() {
    i(window.matchMedia(e).matches);
  }
  return d(() => {
    const n = window.matchMedia(e);
    return a(), n.addEventListener("change", a), () => {
      n.removeEventListener("change", a);
    };
  }, [e]), c;
}
export {
  o as useMediaQuery
};
